import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from './Topbar';
import { TierProvider } from '../context/TierContext';

/** App chrome for authenticated pages: the design's `.app` container + topbar. */
export default function Layout() {
  return (
    <TierProvider>
      <div className="app">
        <Topbar />
        <Outlet />
      </div>
    </TierProvider>
  );
}
